import { motion } from 'framer-motion';
import { fadeUp, defaultViewport } from './ui/AnimationVariants';

const OperationalSection = ({ icon: Icon, title, body }) => (
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={defaultViewport}
    className="bg-navy-700 p-8 border border-navy-600 border-l-2 border-l-primary-500"
  >
    {Icon && <Icon className="h-6 w-6 text-primary-500 mb-4" />}
    <h3 className="font-heading text-white uppercase text-xl mb-3">{title}</h3>
    <p className="text-slate-400 leading-relaxed">{body}</p>
  </motion.div>
);

export default OperationalSection;
